import React from 'react';
import cateringImg from '../assets/churro8.jpeg';
import './Catering.css';

const occasions = [
  {
    icon: '💒',
    title: 'Weddings & Quinceañeras',
    description: 'Add a sweet, traditional touch to your big day.'
  },
  {
    icon: '🏢',
    title: 'Corporate & Office Events',
    description: 'Reward your team with a live-action churro station.'
  },
  {
    icon: '🎂',
    title: 'Private Parties & Birthdays',
    description: 'Treat your guests to the best handmade snacks in Texas.'
  },
  {
    icon: '🎪',
    title: 'School & Community Festivals',
    description: 'Fresh, wholesome treats that everyone can enjoy.'
  },
  {
    icon: '🙏',
    title: 'Staff & Volunteer Appreciation',
    description: 'Reward your team with a sweet treat that always brings a smile at the first bite.'
  }
];

const Catering = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="catering" className="catering">
      <div className="catering__container">
        <div className="catering__hero">
          <div className="catering__hero-content">
            <span className="catering__label">Catering & Events</span>
            <h2 className="catering__heading">
              Bring the Magic of <span>Churros ATX</span> to Your Next Event
            </h2>
            <p className="catering__intro">
              At Churros ATX, we don't just serve food — we create memories. There is 
              nothing quite like the aroma of fresh cinnamon and sugar or the sight of our 
              traditional Mexican hand-press in action to bring people together. Whether you 
              are celebrating a milestone or hosting a professional gathering, we bring the 
              warmth and heart of our kitchen to yours.
            </p>
            <button className="catering__cta" onClick={scrollToContact}>
              Catering Inquiry
            </button>
            <span className="catering__cta-sub">We are your premium event partner!</span>
          </div>
          <div className="catering__hero-image">
            <img src={cateringImg} alt="Churros ATX Catering" />
          </div>
        </div>

        <div className="catering__occasions">
          <h3 className="catering__section-title">Perfect for Every Occasion</h3>
          <p className="catering__section-subtitle">
            From intimate gatherings to grand celebrations, we specialize in:
          </p>
          <div className="catering__occasions-grid">
            {occasions.map((item, idx) => (
              <div key={idx} className="catering__occasion-card">
                <div className="catering__occasion-icon">{item.icon}</div>
                <h4 className="catering__occasion-title">{item.title}</h4>
                <p className="catering__occasion-desc">{item.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="catering__closing">
          <h3 className="catering__closing-title">Let's Celebrate Together!</h3>
          <p className="catering__closing-text">
            Ready to make your event unforgettable? Reach out to us today to discuss your 
            date, location, estimated guests, and how we can bring the "life-changing" 
            flavors of Churros ATX to your celebration.
          </p>
          <button className="catering__closing-cta" onClick={scrollToContact}>
            Get in Touch
          </button>
        </div>
      </div>
    </section>
  );
};

export default Catering;
